import EventAnalytics from "~/js/utilities/EventAnalytics";

import { FileApi } from "~/solidJs/shared/api/fileApi";
import { CustomRuntimeError } from "~/solidJs/shared/models/errors/runtimeErrors";

/**
 * @param {string} url Url to fetch
 * @return {File} File
 * */
export async function fetchLocalImageAsFile(url) {
	const blob = await (await fetch(url)).blob();
	const filename = url.split("/").pop();
	const file = new File([blob], filename, { type: blob.type });

	return file;
}

export async function pullAssetViaAws(id, signal) {
	try {
		console.log(`Pulling file (by id = ${id}} from storage...`);
		const urlToAws = await FileApi.getLinkToAwsByFileId(id, signal);

		const file = await FileApi.getFileFromAws(id, urlToAws, signal);

		return file;
	} catch (err) {
		EventAnalytics.sendErrorInfo("error-pulling-file", {
			file_id: id,
			message: err.message,
			...(err.response ? { statusCode: err.response.status } : {})
		});
		throw new CustomRuntimeError(
			"Unable to download files. Please check your internet connection and try again.",
			{ cause: err }
		);
	}
}
/**
 *
 * @param {*} blob
 * @param {*} fileName
 * @param {*} type
 * @returns {IFileType}
 */
export function blobToFile(blob, fileName, type) {
	console.log("Convert blob to file", { blob, fileName, type });
	return new File([blob], fileName, { lastModified: Date.now(), type });
}
